import store from '../store/index'
import Swal from 'sweetalert2';

function formatNumber(decimalCount, amount, symbol, thousands = ",", decimal = ".") {
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        // Convert the amount to a fixed-point notation
        amount = Number(amount).toFixed(decimalCount);

        // Use regex to remove unnecessary trailing zeros and the decimal point if it is an integer
        let [integerPart, fractionalPart] = amount.split('.');

        // Trimming the fractional part of trailing zeros if necessary
        if (fractionalPart) {
            fractionalPart = fractionalPart.replace(/0+$/, '');
        }

        let i = Math.abs(parseInt(integerPart)).toString(); // Ensure the integer part is positive for the split
        let j = i.length > 3 ? i.length % 3 : 0;

        return (
            symbol +
            ' ' +
            negativeSign +
            (j ? i.substr(0, j) + thousands : '') +
            i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
            (fractionalPart ? decimal + fractionalPart : '')
        );
    } catch (e) {
        console.error(e);
    }
}

export const utils = {
    toPascalCase(string) {
        return string
            .replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
            .replace(/^\w/, s => s.toUpperCase());
    },
    cutLength(string, limit = 45) {
        if (string.length < limit) {
            return string
        } else {
            return string.toString().substring(0, limit).concat('...')
        }
    },

    formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",", isCurrency = true) {
        amount = this.roundAmount(amount,decimalCount);
        if (!isCurrency) {
            return formatNumber(decimalCount, amount, '', thousands, decimal);
        }
        let currency = `K`;
        return formatNumber(decimalCount, amount, currency, thousands, decimal);
    },

    formatCurrency(amount, decimalCount = 2,currency) {
        if (!currency) currency = ``;
        return formatNumber(decimalCount, amount, currency);
    },

    formatQTY(amount) {
        amount = this.roundAmount(amount,3);
        return this.formatMoney(amount, 3, '.', ',',false);
    },

    roundAmount(amount , decimalPlaces = 2){
        if (typeof amount === 'string'){
            amount = amount.replace(`,`,``);
            amount = Number(amount);
        }
        amount = amount.toFixed(decimalPlaces);
        return Number(amount);
    },

    removeIf(arr, predicate) {
        return arr.filter(predicate);
    },
    remove(arr, obj) {
        return arr.filter(v => v !== obj)
    },

    getNow() {
        let date = new Date();
        return date.toISOString().split('T')[0];
    },
    showLoading: () => {
        return Swal.fire({
            icon: "info",
            title: 'Please wait...',
            html: 'Processing your request...', // Optional message
            allowOutsideClick: false,
            timerProgressBar: true,
            showCloseButton: true,
            didOpen: () => {
                Swal.showLoading()
            },
        });
    },
    hideLoading: () => {
        Swal.close()
    },
}

